import $ from "jquery";
import moment from "moment-timezone";

async function init(e) {
  const key = "657c2feff29483c19afe6e4f379fc201"; // OpenWeatherMap API key
  const lat = $(e).data("lat");
  const lon = $(e).data("lon");

  const apiUrl =
    "https://api.openweathermap.org/data/2.5/onecall?lat=" +
    lat +
    "&lon=" +
    lon +
    "&appid=" +
    key;

  const getCardinal = angle => {
    const degreePerDirection = 360 / 8;
    const offsetAngle = angle + degreePerDirection / 2;
    return offsetAngle >= 0 * degreePerDirection &&
      offsetAngle < 1 * degreePerDirection
      ? "N"
      : offsetAngle >= 1 * degreePerDirection &&
        offsetAngle < 2 * degreePerDirection
      ? "NE"
      : offsetAngle >= 2 * degreePerDirection &&
        offsetAngle < 3 * degreePerDirection
      ? "E"
      : offsetAngle >= 3 * degreePerDirection &&
        offsetAngle < 4 * degreePerDirection
      ? "SE"
      : offsetAngle >= 4 * degreePerDirection &&
        offsetAngle < 5 * degreePerDirection
      ? "S"
      : offsetAngle >= 5 * degreePerDirection &&
        offsetAngle < 6 * degreePerDirection
      ? "SW"
      : offsetAngle >= 6 * degreePerDirection &&
        offsetAngle < 7 * degreePerDirection
      ? "W"
      : "NW";
  };

  const currentWeather = d => {
    const temp = Math.round(parseFloat(d.current.temp) - 273.15);
    const min = Math.round(parseFloat(d.daily[0].temp.min) - 273.15);
    const max = Math.round(parseFloat(d.daily[0].temp.max) - 273.15);
    const speed = Math.round(parseFloat(d.current.wind_speed) * 1.944);
    const direction = getCardinal(d.current.wind_deg);
    const gust = Math.round(parseFloat(d.current.wind_gust) * 1.944);
    const conditions = d.current.weather[0].icon;

    $("#weather-conditions").addClass(
      conditions ? "weather__conditions--" + conditions : ""
    );
    $("#weather-temp").html(temp ? temp : "0");
    $("#weather-min").html(min ? min : "0");
    $("#weather-max").html(max ? max : "0");
    $("#wind-speed").html(
      speed
        ? $("#wind-speed").data("speed") + " <span>" + speed + "</span> kts"
        : ""
    );
    $("#wind-gust").html(
      gust
        ? $("#wind-gust").data("gust") + " <span>" + gust + "</span> kts"
        : ""
    );
    $("#wind-direction").html(
      direction
        ? $("#wind-direction").data("direction") +
            " <span>" +
            direction +
            "</span>"
        : ""
    );
  };

  const weatherForecast = d => {
    let newDay;
    let date;
    let min;
    let max;
    let conditions;

    for (const day of d.daily) {
      date = moment.unix(day.dt).format("ddd Do");
      min = Math.round(parseFloat(day.temp.min) - 273.15);
      max = Math.round(parseFloat(day.temp.max) - 273.15);
      conditions = day.weather[0].icon;

      if (moment.unix(day.dt).isSame(moment(), "day") === true) {
        date = "Today";
      }

      if (moment.unix(day.dt).isSame(moment().add(1, "day"), "day") === true) {
        date = "Tomorrow";
      }

      newDay =
        "<div class=\"weather-forecast__column\"><div class=\"weather__today\">" +
        date +
        "</div>" +
        "<div class=\"weather__conditions weather__conditions--" +
        conditions +
        "\"></div>" +
        "<div class=\"weather__high\">" +
        max +
        "<sup>&deg;c</sup></div>" +
        "<div class=\"weather__low\">" +
        min +
        "<sup>&deg;c</sup></div></div>";

      $("#weather-forecast").append(newDay);
    }
  };

  if (lat && lon) {
    $.get(apiUrl, data => {
      if ($(e).attr("id") === "weather-widget") {
        currentWeather(data);
      } else {
        weatherForecast(data);
      }
    });
  }
}

export default { init };
